import { Injectable } from "@angular/core";

@Injectable({
    providedIn:'root'
})

export class coreService{

    api:string=''
    constructor(){
        if (window.location.hostname == 'localhost')
            this.api = `https://${window.location.hostname}:7233/api/`
        else
           // this.api = `http://${window.location.hostname}:81/api/`
           this.api=`https://${window.location.hostname.replace('csrworkstation','csrworkstation-api')}/api/`
          //this.api ='https://oui-csrworkstation-api.allstar-dev.technology/api/';
    }

    getAPi(){
        return this.api;
    }
}
